import React from 'react';
import { Box, SystemStyleObject } from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import ReactDatepicker from 'react-datepicker';

const selectStyle: SystemStyleObject = {
  color: 'text.title',
  bgColor: 'surface.control',
  borderRadius: '4px',
  px: '4px',
  py: '2px',
  mt: '10px',
};

export type StyledDatePickerProps = React.ComponentProps<
  typeof ReactDatepicker
>;

export const StyledDatePicker: React.FC<StyledDatePickerProps> = (props) => {
  return (
    <Box
      w="100%"
      sx={{
        '.react-datepicker-wrapper': {
          width: '100%',
        },
        '.react-datepicker': {
          border: 'none',
          fontFamily: 'marketingPage',
          width: '100%',
          bg: 'transparent',
        },
        '.react-datepicker__month-container': {
          width: '100%',
        },
        '.react-datepicker__header': {
          bg: 'transparent',
          borderBottom: 'none',
          pt: 4,
          width: '100%',
        },
        '.react-datepicker__current-month': {
          fontWeight: 'bold',
          fontSize: '16px',
          color: 'text.title',
          mb: 2,
        },
        '.react-datepicker__day-names': {
          display: 'flex',
          justifyContent: 'space-around',
          pb: 2,
          width: '100%',
        },
        '.react-datepicker__day-name': {
          color: 'gray.500',
          fontSize: '12px',
          fontWeight: 'normal',
          flex: 1,
          textAlign: 'center',
          lineHeight: '36px',
        },
        '.react-datepicker__month': {
          m: 0,
          p: 4,
          width: '100%',
        },
        '.react-datepicker__week': {
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
        },
        '.react-datepicker__day': {
          flex: 1,
          height: '36px',
          lineHeight: '36px',
          borderRadius: 'md',
          fontSize: '14px',
          color: 'text.body',
          m: 0,
          textAlign: 'center',
          _hover: {
            bg: 'surface.greenHover',
            color: 'green.600',
          },
        },
        '.react-datepicker__day--selected': {
          bg: 'icon.green !important',
          color: 'white !important',
          fontWeight: 'bold',
        },
        '.react-datepicker__day--in-range': {
          bg: 'surface.greenHover !important',
          color: 'text.title !important',
        },
        '.react-datepicker__day--keyboard-selected': {
          bg: 'surface.hover !important',
          color: 'text.title !important',
        },
        '.react-datepicker__day--range-start': {
          bg: 'icon.green !important',
          color: 'white !important',
          borderTopLeftRadius: 'md',
          borderBottomLeftRadius: 'md',
        },
        '.react-datepicker__day--range-end': {
          bg: 'icon.green !important',
          color: 'white !important',
          borderTopRightRadius: 'md',
          borderBottomRightRadius: 'md',
        },
        '.react-datepicker__day--in-selecting-range': {
          bg: 'surface.greenHover !important',
          color: 'text.title !important',
        },
        '.react-datepicker__day--outside-month': {
          color: 'gray.400',
        },
        '.react-datepicker__day--disabled': {
          color: 'gray.300',
          cursor: 'not-allowed',
        },
        '.react-datepicker__navigation': {
          top: '20px',
        },
        '.react-datepicker__navigation-icon::before': {
          borderColor: 'gray.600',
        },
        '.react-datepicker__month-select': selectStyle,
        '.react-datepicker__year-select': selectStyle,
      }}>
      <ReactDatepicker {...props} />
    </Box>
  );
};
